export function fmt1(n: number): string {
  return (Math.round(n * 10) / 10).toFixed(1);
}
